var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tabs",
    {
      model: {
        value: _vm.activeName,
        callback: function ($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "Common", name: "common" } },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isBusy,
                  expression: "isBusy",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "element-loading-spinner": "el-icon-loading",
                "label-width": "205px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Title", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Title" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Name" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Brand", prop: "brand_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      model: {
                        value: _vm.form.brand_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "brand_id", $$v)
                        },
                        expression: "form.brand_id",
                      },
                    },
                    _vm._l(_vm.brandOptions, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.label, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Representative", prop: "representative_id" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      model: {
                        value: _vm.form.representative_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "representative_id", $$v)
                        },
                        expression: "form.representative_id",
                      },
                    },
                    _vm._l(_vm.representativeOptions, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.label, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Provider", prop: "provider_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      model: {
                        value: _vm.form.provider_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "provider_id", $$v)
                        },
                        expression: "form.provider_id",
                      },
                    },
                    _vm._l(_vm.providerList, function (option) {
                      return _c("el-option", {
                        key: option.id,
                        attrs: { label: option.name, value: option.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Email Address", prop: "email_address_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      model: {
                        value: _vm.form.email_address_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email_address_id", $$v)
                        },
                        expression: "form.email_address_id",
                      },
                    },
                    _vm._l(_vm.emailAddressList, function (option) {
                      return _c("el-option", {
                        key: option.id,
                        attrs: { label: option.address, value: option.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Phone Number", prop: "phone_number" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Phone Number" },
                    model: {
                      value: _vm.form.phone_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone_number", $$v)
                      },
                      expression: "form.phone_number",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Reject all inbound calls",
                    prop: "reject_calls",
                  },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.reject_calls,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reject_calls", $$v)
                      },
                      expression: "form.reject_calls",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Allow unapproved messages",
                    prop: "allow_unapproved_messages",
                  },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.allow_unapproved_messages,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "allow_unapproved_messages", $$v)
                      },
                      expression: "form.allow_unapproved_messages",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-create px-4", on: { click: _vm.store } },
            [_vm._v("Store")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            label: "User Bindings",
            name: "binding",
            disabled: !_vm.isEditMode,
          },
        },
        [_c("users-table", { attrs: { url: _vm.usersIndexUrl } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }